// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"1bc73239","461":"1c662fe0","561":"928b801d","881":"7cb18f83"}[chunkId] + ".chunk.css";
};